<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useFunctionGetter, useStore } from 'dashboard/composables/store';

import WootReports from './components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const route = useRoute();
const store = useStore();
const team = useFunctionGetter('teams/getTeamById', route.params.id);
const loadState = ref('loading');

const loadTeams = async () => {
  loadState.value = 'loading';
  try {
    await store.dispatch('teams/get');
    loadState.value = team.value.id ? 'ready' : 'not_found';
  } catch {
    loadState.value = 'error';
  }
};

onMounted(loadTeams);
</script>

<template>
  <WootReports
    v-if="team.id"
    :key="team.id"
    type="team"
    getter-key="teams/getTeams"
    action-key="teams/get"
    :selected-item="team"
    :download-button-label="$t('TEAM_REPORTS.DOWNLOAD_TEAM_REPORTS')"
    :report-title="$t('TEAM_REPORTS.HEADER')"
    has-back-button
  />
  <div v-else-if="loadState === 'loading'" class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
  <div v-else class="flex w-full flex-col items-center gap-3 py-20 text-center">
    <p class="m-0 text-n-slate-11">
      {{
        $t(
          loadState === 'error'
            ? 'REPORT.DATA_FETCHING_FAILED'
            : 'REPORT.FILTER_ACTIONS.EMPTY_LIST'
        )
      }}
    </p>
    <V4Button
      v-if="loadState === 'error'"
      :label="$t('REPORT.FILTER_PANEL.RETRY')"
      size="sm"
      @click="loadTeams"
    />
  </div>
</template>
